import { useEffect, useState } from 'react';
import AuthHeader from './AuthHeader';
import AuthForm from './AuthForm';
import usePostData from 'hooks/usePostData';

import translating from '../translate.json';

const LoginForm = () => {
  const { res, error, postData } = usePostData();
  const [errFun, setErrFun] = useState();

  useEffect(() => {
    if (error)
      errFun?.set('apiError', {
        message: error.apiError
      });
  }, [error]);

  useEffect(() => {
    if (res)
      if (res.sessionId) {
        sessionStorage.setItem('otpMvmt', res.otp);
        sessionStorage.setItem('mobileMvmt', res.mobile);
        sessionStorage.setItem('sessionMvmt', res.sessionId);
        window.location.href = '/verification';
      }
  }, [res]);

  const handleSubmit = (data, setError) => {
    setErrFun({ set: setError });
    postData('auth/login', data);
  };

  const fields = [
    {
      name: 'email',
      label: translating.email,
      pattern: {
        value:
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: translating.emailFormatErrMsg
      },
      placeholder: translating.typeEmail
    },
    {
      name: 'password',
      label: translating.password,
      placeholder: translating.typePassword
    }
  ];

  return (
    <div className="login-form">
      <AuthHeader
        title={translating.entringLabel}
        description={translating.typeEmailAndPassword}
      ></AuthHeader>
      <AuthForm
        fields={fields}
        link={{
          href: '/forgot-password',
          text: translating.forgotPasswordLink
        }}
        handleClickSubmit={handleSubmit}
      ></AuthForm>
    </div>
  );
};

export default LoginForm;
